module.exports = __webpack_public_path__ + "img/novos-talentos-deck.c21af632.png";